module.exports = __webpack_public_path__ + "static/media/galeryAbout12.4619f13e.jpg";